import { createFileRoute, redirect } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

export const Route = createFileRoute('/_auth/LicenseIssue')({
  component: RouteComponent,
  beforeLoad: async (beforeLoadContextOptions) => {
    if (!beforeLoadContextOptions.context.licenseChecker.getHasUserValidLicense()) {
      return;
    }

    throw redirect({
      to: '/',
    });
  },
});

function RouteComponent() {
  const { t } = useTranslation();

  return (
    <div style={{ display: 'flex', justifyContent: 'center' }}>
      <h1>{t('license.invalid')}</h1>
    </div>
  );
}
